<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>成员列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" label-width="50px">
                <el-form-item label="成员">
                    <el-input v-model="formFilter.keywords" placeholder="请输入成员名称"></el-input>
                </el-form-item>
                <el-form-item label="角色">
                    <el-select v-model="formFilter.group" placeholder="请选择角色">
                        <el-option
                            v-for="(item, index) in roleList"
                            :key="index"
                            :label="item.name"
                            :value="item.role_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                    <el-button type="default" @click="goPage('/index/info/editmember?handler=0')">添加</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="detail-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="lists"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="real_name"
                        align="center"
                        label="姓名">
                    </el-table-column>
                    <el-table-column
                        prop="username"
                        align="center"
                        label="账号">
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        align="center"
                        label="手机号">
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        align="center"
                        label="邮箱">
                    </el-table-column>
                    <el-table-column
                        prop="role_name"
                        align="center"
                        label="角色权限">
                    </el-table-column>
                    <el-table-column
                        prop="last_login_time"
                        align="center"
                        label="最后登录时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status === 0">已启用</span>
                            <span v-else>已禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <span v-if="scope.row.role_id === 1">-</span>
                            <div v-if="scope.row.role_id !== 1 && scope.row.status === 0">
                                <el-button type="text" @click="goPage(`/index/info/editmember?handler=1&id=${scope.row.id}`)">
                                    编辑
                                </el-button>
                                <el-button type="text" @click="changeStatus(scope.row.id, 1)">
                                    禁用
                                </el-button>
                            </div>
                            <div v-if="scope.row.role_id !== 1 && scope.row.status !== 0">
                                <el-button type="text" @click="changeStatus(scope.row.id, 0)">
                                    启用
                                </el-button>
                                <el-button type="text" @click="delMember(scope.row.id)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Members',
    inject: ['goPage'],
    data () {
        let roleList = [
            {
                'role_id': 1,
                'name': '\u7ba1\u7406\u5458',
                'status': 0,
                'remark': '\u62e5\u6709\u6240\u6709\u6743\u9650',
                'create_time': '2019-10-18 10:44:07',
                'update_time': '2019-10-18 10:44:07'
            }, {
                'role_id': 2,
                'name': '\u4e1a\u52a1\u7ba1\u7406',
                'status': 0,
                'remark': '\u62e5\u6709\u9879\u76ee\u7ba1\u7406\u7b49\u6743\u9650',
                'create_time': '2019-10-18 10:44:07',
                'update_time': '2019-10-18 10:44:07'
            }, {
                'role_id': 3,
                'name': '\u8d22\u52a1\u7ba1\u7406',
                'status': 0,
                'remark': '\u652f\u4ed8\u670d\u52a1\u6210\u679c\u91d1\u989d,\u8d44\u91d1\u7ba1\u7406\u7b49\u6743\u9650',
                'create_time': '2019-10-18 10:44:07',
                'update_time': '2019-10-18 10:44:07'
            }
        ]
        return {
            roleList,
            lists: [],
            formFilter: {
                keywords: '',
                group: ''
            },
            total_page: 1
        }
    },
    mounted () {
        this.formFilter.group = this.$route.query.role * 1 || ''
        this.getRoleList()
        this.getList()
    },
    methods: {
        getRoleList () {
            this.$http.get('/api/user/rbac/rolelist')
                .then(res => {
                    if (res.code === 0) {
                        this.roleList = res.data.listData
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        onFilter () {
            this.getList(1)
        },
        getList (page = 1) {
            this.$http.get('/api/user/userlists', {
                params: {
                    ...this.formFilter,
                    page,
                    size: 10
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.lists = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.warning(res.message)
                })
        },
        changeStatus (id, status) {
            this.$confirm(`此操作将${status === 0 ? '启用' : '禁用'}该成员账户，是否继续？`, '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.queryChangeStatus(id, status)
                })
        },
        delMember (id, status) {
            this.$confirm(`此操作将删除该成员账户，是否继续？`, '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.queryDelete(id)
                })
        },
        queryChangeStatus (id, status) {
            this.$http.get('/api/user/userban', {
                params: {
                    id,
                    status
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.getList()
                        this.$notify.success({
                            title: '通知',
                            message: `账户${status === 0 ? '启用' : '禁用'}成功。`
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error(res.message)
                })
        },
        queryDelete (id) {
            this.$http.get('/api/user/userdelete', {
                params: {
                    id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.getList()
                        this.$notify.success({
                            title: '通知',
                            message: `账号删除成功。`
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$message.error(res.message)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var.scss";
    @import "../../assets/style/sub.scss";

    .detail-box {
        margin-top: 10px;
        padding: 0 0 0 0;

        .detail-item {
            padding-left: 0;
        }
    }
</style>
